import { withInstall } from '@sgui-plus/utils/with-install'

import Badge from './src/badge.vue'

export const SgBadge = withInstall(Badge)
export default SgBadge

export * from './src/badge'
